export const trackEvent = (event: string, data?: Record<string, unknown>) => {
  console.log(`[DUMBVERSE] ${event}`, data ?? '');
};
